import { AuthenticatedLayout } from "../../layouts";
import { FC } from "react";
import { UploadDocuments } from "../../components/UploadDocuments/UploadDocuments";
import { useParams } from "react-router-dom";

export const UploadDocumentsPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle={`Upload Documents`}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Upload Documents", navigateTo: "#" }
      ]}
      mainContents={<UploadDocuments />}
    />
  );
};
